module.exports = __webpack_public_path__ + "assets/images/project/constituencies/holland-bukit-timah-grc.jpg?v=734fbb38";